module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index-concepts.json
// module id = 245
// module chunks = 60335399758886 159264293819137